export const RIGHTS = {
    CANDIDATE_VIEW: "CANDIDATE_VIEW",
    CANDIDATE_ADD: "CANDIDATE_ADD",
    CANDIDATE_EDIT: "CANDIDATE_EDIT",
    CANDIDATE_DELETE: "CANDIDATE_DELETE",


    CANDIDATE_PLACEMENT_EDIT: "CANDIDATE_PLACEMENT_EDIT",
    CUSTOMER_VIEW: "CUSTOMER_VIEW",
    CUSTOMER_ADD: "CUSTOMER_ADD",
    CUSTOMER_EDIT: "CUSTOMER_EDIT",
    CUSTOMER_DELETE: "CUSTOMER_DELETE",
    CUSTOMER_APP_ONBOARDING: "CUSTOMER_APP_ONBOARDING",
    CUSTOMER_APP_ONBOARDING_VIEW: "CUSTOMER_APP_ONBOARDING_VIEW",

    VACANCY_VIEW: "VACANCY_VIEW",
    VACANCY_ADD: "VACANCY_ADD",
    VACANCY_EDIT: "VACANCY_EDIT",
    VACANCY_DELETE: "VACANCY_DELETE",

    EXPERIENCE_VIEW: "EXPERIENCE_VIEW",
    EXPERIENCE_ADD: "EXPERIENCE_ADD",
    EXPERIENCE_EDIT: "EXPERIENCE_EDIT",
    EXPERIENCE_DELETE: "EXPERIENCE_DELETE",

    COSTCENTER_VIEW: "COSTCENTER_VIEW",
    COSTCENTER_ADD: "COSTCENTER_ADD",
    COSTCENTER_EDIT: "COSTCENTER_EDIT",
    COSTCENTER_DELETE: "COSTCENTER_DELETE",

    CERTIFICATE_VIEW: "CERTIFICATE_VIEW",
    CERTIFICATE_ADD: "CERTIFICATE_ADD",
    CERTIFICATE_EDIT: "CERTIFICATE_EDIT",
    CERTIFICATE_DELETE: "CERTIFICATE_DELETE",

    EDUCATION_VIEW: "EDUCATION_VIEW",
    EDUCATION_ADD: "EDUCATION_ADD",
    EDUCATION_EDIT: "EDUCATION_EDIT",
    EDUCATION_DELETE: "EDUCATION_DELETE",
    
    SMS_HISTORY_VIEW: "SMS_HISTORY_VIEW",
    SMS_HISTORY_ADD: "SMS_HISTORY_ADD",
    SMS_HISTORY_EDIT: "SMS_HISTORY_EDIT",
    SMS_HISTORY_DELETE: "SMS_HISTORY_DELETE",

    // MAILING_LIST_VIEW: "MAILING_LIST_VIEW",
    // MAILING_LIST_ADD: "MAILING_LIST_ADD",
    // MAILING_LIST_EDIT: "MAILING_LIST_EDIT",
    // MAILING_LIST_DELETE: "MAILING_LIST_DELETE",

    BLACKLIST_VIEW: "BLACKLIST_VIEW",
    BLACKLIST_ADD: "BLACKLIST_ADD",
    BLACKLIST_EDIT: "BLACKLIST_EDIT",
    BLACKLIST_DELETE: "BLACKLIST_DELETE",

    USER_VIEW: "USER_VIEW",
    USER_ADD: "USER_ADD",
    USER_EDIT: "USER_EDIT",
    USER_DELETE: "USER_DELETE",

    OTHER_POOL_VIEW: "OTHER_POOL_VIEW",
    OTHER_APPOINTMENT_VIEW: "OTHER_APPOINTMENT_VIEW",
    OTHER_QUITTERS_VIEW: "OTHER_QUITTERS_VIEW",
    OTHER_IMPORT_ADD: "OTHER_IMPORT_ADD",
    
    ROLE_VIEW: "ROLE_VIEW",
    ROLE_ADD: "ROLE_ADD",
    ROLE_EDIT: "ROLE_EDIT",
    ROLE_DELETE: "ROLE_DELETE",

    ANALYTICS_VIEW: "ANALYTICS_VIEW",

    CONTRACTS_VIEW: "CONTRACTS_VIEW",
    CONTRACTS_ADD: "CONTRACTS_ADD",
    CONTRACTS_EDIT: "CONTRACTS_EDIT",
    CONTRACTS_DELETE: "CONTRACTS_DELETE",

    // HOUR APP ROLES //
    DOCUMENT_VIEW: "DOCUMENT_VIEW",
    DOCUMENT_ADD: "DOCUMENT_ADD",
    DOCUMENT_EDIT: "DOCUMENT_EDIT",
    DOCUMENT_DELETE: "DOCUMENT_DELETE",

    HOURS_VIEW: "HOURS_VIEW",
    HOURS_ADD: "HOURS_ADD",
    HOURS_EDIT: "HOURS_EDIT",
    HOURS_DELETE: "HOURS_DELETE",
    HOURS_EXTRA_PAYMENT: "HOURS_EXTRA_PAYMENT",

    CONFIG_VIEW: "CONFIG_VIEW",
    CONFIG_ADD: "CONFIG_ADD",
    CONFIG_EDIT: "CONFIG_EDIT",
    CONFIG_DELETE: "CONFIG_DELETE",
    CONFIG_HOURS: "CONFIG_HOURS",

    METRICS_VIEW: "METRICS_VIEW",
    METRICS_ADD: "METRICS_ADD",
    METRICS_EDIT: "METRICS_EDIT",
    METRICS_DELETE: "METRICS_DELETE",

    NOTIFICATIONS_VIEW: "NOTIFICATIONS_VIEW",
    NOTIFICATIONS_ADD: "NOTIFICATIONS_ADD",
    NOTIFICATIONS_EDIT: "NOTIFICATIONS_EDIT",
    NOTIFICATIONS_DELETE: "NOTIFICATIONS_DELETE",

    SHIFT_VIEW: "SHIFT_VIEW",
    SHIFT_ADD: "SHIFT_ADD",
    SHIFT_EDIT: "SHIFT_EDIT",
    SHIFT_DELETE: "SHIFT_DELETE",

    CHAT_VIEW: "CHAT_VIEW",
    CHAT_ADD: "CHAT_ADD",
    CHAT_EDIT: "CHAT_EDIT",
    CHAT_DELETE: "CHAT_DELETE",

    LEAVEREQUESTS_VIEW: "LEAVEREQUESTS_VIEW",
    LEAVEREQUESTS_ADD: "LEAVEREQUESTS_ADD",
    LEAVEREQUESTS_EDIT: "LEAVEREQUESTS_EDIT",
    LEAVEREQUESTS_DELETE: "LEAVEREQUESTS_DELETE",

    // Special roles //
    IS_CUSTOMER: "IS_CUSTOMER",
    IS_EMPLOYEE: "IS_EMPLOYEE",
    IS_ADMIN: "IS_ADMIN",
}